import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SpacerBlockConfig } from '@front-platform/content-builder';
import { spacerBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface SpacerBlockRuntimeConfig {}

export type SpacerBlockConfigInput = Partial<
  Omit<SpacerBlockConfig, keyof SpacerBlockRuntimeConfig> & SpacerBlockRuntimeConfig
>;
export type SpacerBlockResolvedConfig = Omit<SpacerBlockConfig, keyof SpacerBlockRuntimeConfig> &
  Partial<SpacerBlockRuntimeConfig>;
export interface SpacerBlockContract extends ConfigComponentContract<
  SpacerBlockConfigInput,
  SpacerBlockResolvedConfig
> {}

@Component({
  selector: 'app-spacer-block',
  templateUrl: './spacer-block.component.html',
  standalone: false,
})
export class SpacerBlockComponent implements SpacerBlockContract {
  readonly config = input<SpacerBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<SpacerBlockConfig, SpacerBlockRuntimeConfig>(
    spacerBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get height(): number {
    return this.resolvedConfig()['height'] as unknown as number;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SpacerBlockComponent, { 'keyAliases': {} });
